import React from 'react';
import Switch from 'material-ui/Switch';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setDarkTheme, setThemeColor } from 'actions/index';
import UpdateLayoutt from './LayoutCell/index';
import layoutInfo from 'app/routes/components/routes/AdminPanel/data/heartbeatList';
import { arrayMove, SortableContainer } from 'react-sortable-hoc';
import {
    AMBER,
    BLUE,
    CYAN,
    DARK_AMBER,
    DARK_BLUE,
    DARK_CYAN,
    DARK_DEEP_ORANGE,
    DARK_DEEP_PURPLE,
    DARK_GREEN,
    DARK_INDIGO,
    DARK_PINK,
    DEEP_ORANGE,
    DEEP_PURPLE,
    GREEN,
    INDIGO,
    PINK,
} from 'constants/ThemeColors';
import { Button } from 'material-ui';
import SweetAlert from 'react-bootstrap-sweetalert';
import { persistConfig } from 'store/index';
import { purgeStoredState } from 'redux-persist';
import { signOut } from 'util/user-manager';
import {
    requestStateWiseDevices,
    requestAustraliaLocations,
    updateDeviceCount,
    updateThemeConfiguration
} from 'util/aws-manager';
import * as CONST from 'util/app-constants';
import { CircularIndeterminate2 } from '../progressbar/circular/indeterminate/CircularIndeterminate';
import { NotificationContainer } from 'react-notifications';
import { createNotification } from 'util/util';
import { uploadLogo } from 'util/fileManager';
import { getMqttClient } from 'util/aws-manager';

const LayoutInfo = SortableContainer(({ layoutInfo }) => {
    return (
        <div>
            <div className="row mx-0">
                {layoutInfo.map((contact, index) => (
                    <UpdateLayoutt key={index} index={index} contact={contact} />
                ))}
            </div>

        </div>
    );
});

class SetThemeColor extends React.Component {
    deviceCount;
    signOutTimeout;
    signOutInterval;

    mapLatLongToStates = (latLong) => {
        const self = this;
        return new Promise(((resolve, reject) => {
            $.getJSON(CONST.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART + latLong + CONST.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART, (data) => {
                if (data.results.length !== 0) {
                    switch (data.results[0].address_components[0].short_name) {
                        case 'NSW':
                            self.setState({ NSWCount: self.state.NSWCount + 1 });
                            break;
                        case 'SA':
                            self.setState({ SACount: self.state.SACount + 1 });
                            break;
                        case 'WA':
                            self.setState({ WACount: self.state.WACount + 1 });
                            break;
                        case 'NT':
                            self.setState({ NTCount: self.state.NTCount + 1 });
                            break;
                        case 'QLD':
                            self.setState({ QLDCount: self.state.QLDCount + 1 });
                            break;
                        case 'VI':
                            self.setState({ VICount: self.state.VICount + 1 });
                            break;
                        case 'TA':
                            self.setState({ TACount: self.state.TACount + 1 });
                            break;
                    }

                    resolve(data.results[0].address_components[0].short_name);
                }
            }).fail((jqXHR, textStatus, errorThrown) => {
                reject(errorThrown);
            });
            // }
        }));
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            layoutInfo: arrayMove(this.state.layoutInfo, oldIndex, newIndex),
        });
    };

    handleThemeColor = (colorCode) => {
        this.props.setThemeColor(colorCode);
        const body = $('#body');
        body.removeClass(this.props.themeColor);
        body.removeClass('dark-theme');
        body.addClass(colorCode);
        this.setDefaultThemeColor(colorCode);
        this.setState({ setGroupThemeColor: colorCode });
    };

    handleDarkTheme = () => {
        this.props.setDarkTheme();
        const body = $('#body');
        body.toggleClass(this.props.themeColor);
        body.toggleClass('dark-theme');
        this.setDefaultThemeColor('dark-theme');
        this.setState({ setGroupThemeColor: 'dark-theme' });
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.symbioticReducer.hasOwnProperty('layoutHeartbeat')) {
            this.setState({ layoutInfo: nextProps.symbioticReducer.layoutHeartbeat });
        }
        if (this.state.isMARight !== nextProps.symbioticReducer.isMARight) {
            this.setState({ isMARight: nextProps.symbioticReducer.isMARight });
        }
        if (nextProps.symbioticReducer.deviceId !== this.state.deviceId) {
            this.setState({
                deviceId: nextProps.symbioticReducer.deviceId
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            drawerStatus: false,
            setGroupThemeColor: '',
            layoutInfo,
            isMARight: true,
            isSignOutAlertShown: false,
            signoutTimeLeft: 10,
            numberOfDevices: 0,
            WACount: 0,
            NTCount: 0,
            QLDCount: 0,
            SACount: 0,
            NSWCount: 0,
            VICount: 0,
            TACount: 0,

            link: this.props.symbioticReducer.linkOfLogo,
            deviceId: this.props.symbioticReducer.deviceId,
        };
        this.getAllDevices();
    }

    componentDidMount() {
        $('#body').addClass(this.props.themeColor);
        $('.theme_color').slimscroll({
            height: '100%',
        });
        this.calculateNumberOfDevices();
    }

    setDefaultThemeColor = () => {
        // initialSettings.themeColor = colorCode;
    }

    resetLayout = () => {
        this.setState({
            layoutInfo,
        });
    };

    // toggleLightDarkThemeColors() {
    //     $('#lightThemeColor').toggleClass('d-none');
    //     $('#darkThemeColor').toggleClass('d-none');
    // }

    updateGroupName = () => {

        const self = this;

        const content = JSON.stringify({
            theme: {
                name: this.state.setGroupThemeColor,
            },
        });
        updateThemeConfiguration(CONST.USER_POOL_ID, content, null)
            .then(() => {
                self.showSuccessAndSignoutPopup();
            });
    }

    updateLayout = () => {

        const self = this;

        const content = JSON.stringify({
            heartbeatData: this.state.layoutInfo,
            maPosition: this.state.isMARight,
        });
        updateThemeConfiguration(CONST.USER_POOL_ID, null, content)
            .then(() => {
                self.showSuccessAndSignoutPopup();
            });
    }

    changeMAPosition = () => {
        if (this.state.isMARight) {
            this.setState({
                isMARight: false,
            });
        }
        else {
            this.setState({
                isMARight: true,
            });
        }
    }

    signUserOutInnerFunctionality = () => {

        this.props.signOut();
        this.props.setDefaultTheme();
        const body = $('#body');
        body.removeClass();
        body.addClass(this.props.themeColor);
        purgeStoredState(persistConfig);
    };

    signUserOut = () => {
        signOut()
            .then(() => {
                this.setState({
                    isSignOutAlertShown: false,
                    signoutTimeLeft: 10,
                });
                clearInterval(this.signOutInterval);
                clearTimeout(this.signOutTimeout);
                this.signUserOutInnerFunctionality();
            }, () => {
                clearInterval(this.signOutInterval);
                clearTimeout(this.signOutTimeout);
                this.signUserOutInnerFunctionality();
            });
    };

    onCancelClick = () => {
        clearTimeout(this.signOutTimeout);
        clearInterval(this.signOutInterval);
        this.setState({
            isSignOutAlertShown: false,
        });
        this.setState({
            signoutTimeLeft: 10,
        });
    };

    getAllDevices = () => {
        const self = this;
        requestStateWiseDevices(CONST.STATEWISE_DEVICES_TABLE_NAME).then((data) => {
            self.deviceCount = parseInt(data.Items[0].NSW) + parseInt(data.Items[0].WA) + parseInt(data.Items[0].QLD) + parseInt(data.Items[0].NT) + parseInt(data.Items[0].SA) + parseInt(data.Items[0].VI) + parseInt(data.Items[0].TA);
            self.setStateNumberOfDevice();
        }, () => {
        });
    }

    setStateNumberOfDevice = () => {
        this.setState({
            numberOfDevices: this.deviceCount,
        });
    }

    calculateNumberOfDevices = () => {
        const self = this;
        let latLong;
        let stateShortName;
        requestAustraliaLocations(CONST.AUSTRALIA_LOCATIONS_TABLE_NAME).then((data) => {
            for (let i = 0; i < data.Count; i++) {
                latLong = data.Items[i].location;
                stateShortName = self.mapLatLongToStates(latLong).then(() => {
                }, () => {
                });
            }
        });
    }

    updateStateWiseDeviceTable = () => {
        const self = this;
        updateDeviceCount(CONST.STATEWISE_DEVICES_TABLE_NAME, self.state.NSWCount, self.state.WACount, self.state.NTCount, self.state.QLDCount, self.state.SACount, self.state.VICount, self.state.TACount)
            .then(() => {
                createNotification('Devices updated successfully', '', 'Success');
                self.getAllDevices();
            });
    }

    render() {
        const { themeColor, darkTheme } = this.props;

        // console.log("Theme color and dark theme", themeColor, darkTheme);
        const { layoutInfo } = this.state;
        return (

            <div className="row" id="adminPanel">
                <NotificationContainer />
                <SweetAlert
                    show={this.state.isSignOutAlertShown}
                    style={{ color: 'black' }}
                    showCancel
                    confirmBtnBsStyle="primary"
                    cancelBtnBsStyle="primary"
                    title={`Your changes have been saved. Sign out is required for the changes to reflect. You will automatically be signed out in ${this.state.signoutTimeLeft} seconds for the changes to apply!`}
                    cancelBtnText="Cancel"
                    confirmBtnText="SignOut Now"
                    onCancel={this.onCancelClick}
                    onConfirm={this.signUserOut}
                >
                    Click cancel if you want to sign out later.
                </SweetAlert>
                <div className="col-12">
                    <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
                        <h1 className="mb-0">Set Theme Color</h1>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-2 pt-3 pl-4">
                            <h3>Light Sidenav</h3>
                        </div>
                        <div className="col-10 pl-5">
                            <div id="lightThemeColor">
                                <ul className="color-option">
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, INDIGO)}
                                        className={`bg-indigo ${themeColor === INDIGO && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, CYAN)}
                                        className={`bg-cyan ${themeColor === CYAN && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, AMBER)}
                                        className={`bg-amber ${themeColor === AMBER && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DEEP_ORANGE)}
                                        className={`bg-deep-orange ${themeColor === DEEP_ORANGE && 'active'}`}
                                    />
                                    </li>

                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, PINK)}
                                        className={`bg-pink ${themeColor === PINK && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, BLUE)}
                                        className={`bg-blue ${themeColor === BLUE && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DEEP_PURPLE)}
                                        className={`bg-deep-purple ${themeColor === DEEP_PURPLE && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, GREEN)}
                                        className={`bg-green ${themeColor === GREEN && 'active'}`}
                                    />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-2 pt-3 pl-4">
                            <h3>Dark Sidenav</h3>
                        </div>
                        <div className="col-10 pl-5">
                            <div id="darkThemeColor">
                                <ul className="color-option cr-op-dark-sidebar">
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_INDIGO)}
                                        className={`bg-indigo ${themeColor === DARK_INDIGO && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_CYAN)}
                                        className={`bg-cyan ${themeColor === DARK_CYAN && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_AMBER)}
                                        className={`bg-amber ${themeColor === DARK_AMBER && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_DEEP_ORANGE)}
                                        className={`bg-deep-orange ${themeColor === DARK_DEEP_ORANGE && 'active'}`}
                                    />
                                    </li>

                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_PINK)}
                                        className={`bg-pink ${themeColor === DARK_PINK && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_BLUE)}
                                        className={`bg-blue ${themeColor === DARK_BLUE && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_DEEP_PURPLE)}
                                        className={`bg-deep-purple ${themeColor === DARK_DEEP_PURPLE && 'active'}`}
                                    />
                                    </li>
                                    <li><a
                                        href="javascript:void(0)"
                                        onClick={this.handleThemeColor.bind(this, DARK_GREEN)}
                                        className={`bg-green ${themeColor === DARK_GREEN && 'active'}`}
                                    />
                                    </li>
                                    <div className="mt-4">
                                        <h3 className="mb-1 pl-1">Dark Theme</h3>
                                        <Switch
                                            color="primary"
                                            checked={darkTheme}
                                            onChange={this.handleDarkTheme}
                                        />
                                    </div>
                                </ul>
                            </div>
                            <div className="mt-4">
                                <Button
                                    variant="raised"
                                    className="jr-btn bg-primary text-white"
                                    onClick={this.updateGroupName}
                                > Update Theme Color</Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 my-5">
                    <div className="row">
                        <div className="col-lg-2 col-md-12 pt-3 pl-4">
                            <h3>Edit Layout</h3>
                        </div>
                        <div className="col-lg-10 col-md-12 pl-lg-5">
                            <div className="animated slideInUpTiny animation-duration-3">
                                <LayoutInfo
                                    layoutInfo={layoutInfo}
                                    axis="xy"
                                    onSortEnd={this.onSortEnd}
                                    useDragHandle
                                />
                            </div>
                            <div>
                                <h3 className="mb-1 pl-1 mt-4">Movement & Accelaration</h3>
                                <img className="pr-2 pb-1" src="assets/images/maOnLeft.svg" style={{ width: '50px' }} />Left
                                <Switch
                                    color="primary"
                                    checked={this.state.isMARight}
                                    onChange={this.changeMAPosition}
                                />Right
                                <img className="pl-2 pb-1" src="assets/images/maOnRight.svg" style={{ width: '50px' }} />
                            </div>
                            <div className="mt-4">
                                <Button
                                    variant="raised"
                                    className="jr-btn bg-primary text-white"
                                    onClick={this.updateLayout}
                                >Save Layout</Button>
                                <Button
                                    onClick={this.resetLayout}
                                    variant="raised"
                                    className="jr-btn bg-primary text-white"
                                >Reset Layout</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row my-3">
                        <div className="col-lg-2 col-md-12 pt-3 pl-4">
                            <h3>Device Details</h3>
                        </div>
                        <div className="col-lg-10 col-md-12 pl-lg-5 mt-3">
                            <p>Total number of devices placed are</p>
                            {this.state.numberOfDevices || <div className="">
                                <CircularIndeterminate2 />
                            </div>}
                            <div className="mt-4">
                                <Button
                                    variant="raised"
                                    className="jr-btn bg-primary text-white"
                                    onClick={this.updateStateWiseDeviceTable}
                                >Re-Calculate & Save</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row my-3">
                        <div className="col-lg-2 col-md-12 pt-3 pl-4">
                            <h3>Customise Logo</h3>
                        </div>
                        <div className="col-lg-10 col-md-12 pl-lg-5 mt-3">
                            <p>Upload Logo and Link</p>
                            <div>
                                <input className="jr-btn bg-primary text-white" type="file" id="file-chooser" />
                            </div>
                            <div className="mt-3">
                                <input placeholder="Enter Link" className="link-input-style" value={this.state.link}
                                    onChange={(e) => {
                                        this.onLinkTextChange(e)
                                    }} />
                            </div>
                            <div className="mt-3">
                                <Button
                                    variant="raised"
                                    className="jr-btn bg-primary text-white"
                                    onClick={this.UploadLogoAndUpdateLink}
                                >Update logo and link</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    UploadLogoAndUpdateLink = () => {
        const self = this;
        const fileChooser = document.getElementById('file-chooser');

        if (fileChooser.files.length > 0) {
            const imageNameAndExtension = fileChooser.files[0].name.split('.');
            const imageExtension = fileChooser.files[0].name.split('.').pop().toLowerCase();
            const imageName = imageNameAndExtension[0].toLowerCase();
            uploadLogo(fileChooser, `${imageName}.${imageExtension}`)
                .then(() => {
                    const linkInString = JSON.stringify({
                        link: self.state.link,
                    });
                    const linkToLogo = self.imageUrl = `http://${CONST.BUCKET_NAME}.s3.amazonaws.com/logos/${imageName}.${imageExtension}`;
                    updateThemeConfiguration(CONST.USER_POOL_ID, null, null, linkInString, linkToLogo)
                        .then(() => {
                            self.showSuccessAndSignoutPopup();
                        });
                }, (err) => {
                    createNotification(err.message, 'Error', 'Error');
                });
        }
        else if (fileChooser.files.length === 0) {
            const linkInString = JSON.stringify({
                link: self.state.link,
            });
            updateThemeConfiguration(CONST.USER_POOL_ID, null, null, linkInString)
                .then(() => {
                    self.showSuccessAndSignoutPopup();
                });
        }
    }

    showSuccessAndSignoutPopup = () => {
        this.setState({
            isSignOutAlertShown: true,
        });
        this.signOutTimeout = setTimeout(() => {
            this.signUserOut();
        }, 10000);
        this.signOutInterval = setInterval(() => {
            this.setState({
                signoutTimeLeft: this.state.signoutTimeLeft - 1,
            });
        }, 1000);
    };

    onLinkTextChange = (e) => {
        this.setState({
            link: e.target.value,
        });
    };
}

const mapStateToProps = ({ settings, symbioticReducer }) => {
    const { themeColor, darkTheme } = settings;
    return { themeColor, darkTheme, symbioticReducer };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => {
            dispatch({ type: 'SIGN_OUT' });
        },
        setDefaultTheme: () => {
            dispatch({ type: 'SET_DEFAULT_THEME' });
        },
        setThemeColor: (colorCode) => {
            dispatch(setThemeColor(colorCode));
        },
        setDarkTheme: () => {
            dispatch(setDarkTheme());
        },
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SetThemeColor));




// WEBPACK FOOTER //
// ./app/routes/components/routes/AdminPanel/SetThemeColor.js